import {
	Breakpoints,
	Container,
	ContainerGutter,
	ContainerPadding,
	CTA,
	Layout,
	styled,
	Text,
	TextAlignment,
	ThemeProvider,
	ThemeReference,
	TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getHorariosCallMe } from 'src/bff/api/get-horarios-callme';
import { COLOR_TOKEN } from 'src/components/color-token';
import {
	TriggerProps,
	useFaContent,
	useTransformToHtml,
} from 'src/feature-app';
import { CallMeForm } from 'src/forms';

interface contentStageProps {
	formTheme: ThemeReference;
}

const ContentStage = styled.div<contentStageProps>`
	overflow: hidden;
	display: flex;
	justify-content: center;
	align-items: center;
	background: ${props =>
		props.formTheme == 'inverted'
			? COLOR_TOKEN.inverted.gradient.radial
			: COLOR_TOKEN.main.background.primary};
	padding: ${props => (props.formTheme == 'inverted' ? '44px 0' : '0')};

	& > div {
		width: ${props => (props.formTheme == 'inverted' ? '100%' : '92%')};
		margin: ${props => (props.formTheme == 'inverted' ? '0' : '0 4%')};
		border: ${props =>
			props.formTheme == 'inverted'
				? 'none'
				: `2px solid ${COLOR_TOKEN.main.content.primary}`};
	}
`;

export function CallMeTrigger({
	setSelectedJourney,
	setCTALabel,
}: TriggerProps) {
	const faContent = useFaContent();
	const dispatch = useDispatch();
	const [theme, setTheme] = useState<ThemeReference>('inverted');
	const [isOpenNow, setIsOpenNow] = useState<boolean>(false);

	const alternativeHeadline = ' <b>¿Quieres que te llamemos?</b>';
	const getTriggerHeadline = () =>
		faContent?.headline
			? useTransformToHtml(faContent.headline)
			: useTransformToHtml(alternativeHeadline);

	const alternativeBodyCopy =
		'Déjanos tus datos y nos pondremos en contacto contigo lo antes posible.';
	const getTriggerbodycopy = () =>
		faContent?.bodycopy
			? useTransformToHtml(faContent.bodycopy)
			: useTransformToHtml(alternativeBodyCopy);

	const getCtaLabel = () => (faContent?.cta ? faContent.cta : 'Solicitar');

	const handleIsOpenNow = async () => {
		const horarios = await getHorariosCallMe();
		setIsOpenNow(horarios.isOpenNow);
	};

	useEffect(() => {
		if (faContent?.modo === 'Light') {
			setTheme('main');
		}
		handleIsOpenNow();
	}, []);

	return isOpenNow ? (
		<ThemeProvider theme={theme}>
			<ContentStage formTheme={theme}>
				<Layout
					appearance={{
						[Breakpoints.default]: [
							{ name: '.', columns: 2 },
							{ name: 'a', columns: 20 },
							{ name: '.', columns: 2 },
						],
						[Breakpoints.b960]: [
							{ name: '.', columns: 3 },
							{ name: 'a', columns: 18 },
							{ name: '.', columns: 3 },
						],
						[Breakpoints.b1280]: [
							{ name: '.', columns: 4 },
							{ name: 'a', columns: 16 },
							{ name: '.', columns: 4 },
						],
						[Breakpoints.b1600]: [
							{ name: '.', columns: 1 },
							{ name: 'a', columns: 22 },
							{ name: '.', columns: 1 },
						],
					}}
				>
					<Container
						wrap={'always'}
						gutter={ContainerGutter.dynamic0100}
						padding={{
							top: ContainerPadding.dynamic0100,
							bottom: ContainerPadding.dynamic0100,
						}}
					>
						<Text
							textAlign={TextAlignment.center}
							appearance={TokenTextAppearance.headline300}
						>
							<div
								dangerouslySetInnerHTML={getTriggerHeadline()}
							/>
						</Text>
						<Text
							textAlign={TextAlignment.center}
							appearance={TokenTextAppearance.copy200}
						>
							<div
								dangerouslySetInnerHTML={getTriggerbodycopy()}
							/>
						</Text>
						<Container
							wrap={'always'}
							padding={{ top: ContainerPadding.dynamic0100 }}
						>
							<Text textAlign={TextAlignment.center}>
								<CTA
									tag="button"
									onClick={() => {
										dispatch({ type: 'RESET_STATE' });
										setCTALabel(getCtaLabel());
										setSelectedJourney(<CallMeForm />);
									}}
									stretchContent={{
										[Breakpoints.default]: true,
										[Breakpoints.b560]: false,
									}}
								>
									{getCtaLabel()}
								</CTA>
							</Text>
						</Container>
					</Container>
				</Layout>
			</ContentStage>
		</ThemeProvider>
	) : null;
}
